<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand far fa-sticky-note"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่าย :</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'agentCode'"
                  :name="'agentCode'"
                  :select2-options="agentCodeOptions"
                  v-model="agentCode"
                  ref="agentCodeSelect2"
                  @selectChange="agentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <div class="form-group">
                <label>ข้อมูลปี :</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'year'"
                  :name="'year'"
                  :select2-options="yearOptions"
                  v-model="year"
                  ref="year"
                  @selectChange="agentCodeChange"
                ></select2>
              </div>
            </div>
          </div>

          <div v-if="year && canExportAllAgents && !isShow" class="d-flex justify-content-end align-items-center mb-3">
            <button type="button"
                    class="btn btn-outline-primary"
                    @click.prevent="exportExcelAllAgents"
                    :disabled="isExportingAll">
              <span>
                <i class="fas fa-file-export"></i>
                {{ isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)" }}
              </span>
            </button>
          </div>

          <div v-if="isShow == true" class="kt-section kt-section--first">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="kt-section__title">
                รายการจำนวนอุปกรณ์ส่งเสริมสูญหาย :
              </h3>
              <div>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click.prevent="exportExcelSelected"
                        :disabled="isExportingSelected">
                  <span>
                    <i class="fas fa-file-export"></i>
                    {{ isExportingSelected ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายที่เลือก)" }}
                  </span>
                </button>
                <button v-if="canExportAllAgents"
                        type="button"
                        class="btn btn-outline-primary ml-2"
                        @click.prevent="exportExcelAllAgents"
                        :disabled="isExportingAll">
                  <span>
                    <i class="fas fa-file-export"></i>
                    {{ isExportingAll ? "กำลัง Export..." : "Export Excel (ตัวแทนจำหน่ายทั้งหมด)" }}
                  </span>
                </button>
              </div>
            </div>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                    style="min-width:2500px;"
                  >
                    <thead>
                      <tr>
                        <th
                          rowspan="2"
                          scope="rowgroup"
                          class="text-center"
                          width="3%"
                        >
                          ลำดับ
                        </th>
                        <th
                          rowspan="2"
                          scope="rowgroup"
                          class="text-center"
                          width="10%"
                        >
                          ประเภทสินค้า
                        </th>
                        <th
                          rowspan="2"
                          scope="rowgroup"
                          class="text-center"
                          width="7%"
                        >
                          ต้นทุนสินค้า(บาท)
                        </th>
                        <th colspan="12" scope="colgroup" class="text-center">
                          จำนวนอุปกรณ์ส่งเสริมสูญหาย (จำนวน) ปี {{ year }}
                        </th>
                        <th
                          rowspan="2"
                          scope="rowgroup"
                          class="text-center"
                          width="7%"
                        >
                          มูลค่าสินค้ารวม(บาท)
                        </th>
                        <th
                          rowspan="2"
                          scope="rowgroup"
                          class="text-center"
                          width="7%"
                        >
                          มูลค่าสินค้าเฉลี่ย(บาท/เดือน)
                        </th>
                        <th
                          rowspan="2"
                          scope="rowgroup"
                          class="text-center"
                          width="7%"
                        >
                          จัดการ
                        </th>
                      </tr>

                      <tr>
                        <th class="text-center" width="5%">มกราคม</th>
                        <th class="text-center" width="5%">กุมภาพันธ์</th>
                        <th class="text-center" width="5%">มีนาคม</th>
                        <th class="text-center" width="5%">เมษายน</th>
                        <th class="text-center" width="5%">พฤษภาคม</th>
                        <th class="text-center" width="5%">มิถุนายน</th>
                        <th class="text-center" width="5%">กรกฎาคม</th>
                        <th class="text-center" width="5%">สิงหาคม</th>
                        <th class="text-center" width="5%">กันยายน</th>
                        <th class="text-center" width="5%">ตุลาคม</th>
                        <th class="text-center" width="5%">พฤศจิกายน</th>
                        <th class="text-center" width="5%">ธันวาคม</th>
                      </tr>
                    </thead>
                    <tbody @change="changeTotal()">
                      <tr
                        v-if="productitems == null || productitems.length == 0"
                      >
                        <td
                          v-if="this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])"
                          colspan="18"
                          class="text-muted text-center"
                        >
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in productitems">
                        <product-item-row
                          ref="Items"
                          :key="i"
                          :rowIndex="i"
                          :item="item"
                          :kPIProductType="kPIProductType"
                          :yearSelected="year"
                          @removeItem="onRemoveItemClick"
                        ></product-item-row>
                      </template>
                    </tbody>

                    <tfoot>
                      <tr>
                        <th class="text-center" width="3%"></th>
                        <th class="text-center" width="10%">รวมเงิน</th>
                        <th class="text-center" width="7%">
                          {{ totalCost | currency("฿ ", 2) }}
                        </th>
                        <th
                          v-for="index in 12"
                          :key="index"
                          class="text-center"
                          width="5%"
                        >
                          {{ totalMonth[index] | currency(" ", 0) }}
                        </th>
                        <th class="text-center" width="5%">
                          {{ totalPoductCost | currency("฿ ", 2) }}
                        </th>
                        <th class="text-center" width="5%">
                          {{ totalProductCostOfMonth | currency("฿ ", 2) }}
                        </th>
                        <th></th>
                      </tr>
                      <tr>
                        <td
                          colspan="18"
                          v-if="this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])"
                        >
                          <button
                            type="button"
                            class="btn btn-sm btn-brand"
                            @click.prevent="onAddItemClick"
                          >
                            <i class="fa fa-plus"></i> เพิ่มรายการใหม่
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <label class="kt-button"> </label>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          v-if="isShow == true && this.$root.canShow(['ADMIN_5S', 'JOB_AGENT_KPI'])"
          type="submit"
          class="btn btn-primary"
          data-dismiss="modal"
        >
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import datepicker from "../../../Shared/Datepicker";
import select2 from "../../../Shared/Select2";
import productItemRow from "./ProductItemRow";
import { exportExcelFromApi } from "../../../Shared/exportExcelHelper";

export default {
  components: {
    select2,
    datepicker,
    productItemRow,
  },
  data() {
    var self = this;
    return {
      monthCanEdit: 2, /* Default FEB, configurable */
      kPIProductType: "KPI_ACCESSORY_LOST",
      isShow: false,
      isExportingSelected: false,
      isExportingAll: false,
      productitems: [],
      productTotalList: [],
      totalCost: 0,
      totalMonth: [],
      totalPoductCost: 0,
      totalProductCostOfMonth: 0,
      i: 0,
      agentCode: null,
      year: new Date().getFullYear(),
      agentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      yearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
        ],
      },
    };
  },
  computed: {
    canExportAllAgents() {
      return this.$root.canShow(['super_admin', 'ADMIN_5S', 'ADVISOR_5S', 'TEAM_5S']);
    },
  },
  methods: {
    onAddItemClick(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      var listProductCode = [];
      this.productitems.forEach((element) => {
        listProductCode.push(element.productCode);
      });

      this.productitems.push({
        productCode: null,
        productCost: 0,
        isMonth: [],
        totalCal: 0,
        totalCalOfmonth: 0,
        isDisableMonth: [],
        isDisableProduct: false,
        listProductCode: listProductCode,
      });
    },
    onRemoveItemClick(index, delItem) {
      this.productitems.splice(index, 1);
      for (let i = 0; i < this.productitems.length; i++) {}
      this.changeTotal();
    },
    agentCodeChange() {
      let self = this;
      // CR-KPI Issue#4: hide Selected button if no agent picked (or agent cleared)
      if (!self.agentCode) {
        self.isShow = false;
        return;
      }
      self.isShow = true;
      self.productitems = [];
      axios({
        method: "post",
        url: "/Api/KPIProduct/getAccessory",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
        },
      })
        .then(function(response) {
          var date = new Date();
          var monthNo = date.getMonth() + 1;
          var yearNo = date.getFullYear();

          if (response.status == 200) {
            if (response.data != null && response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                var item = response.data[i];
                var monthQtyItem = [];
                var monthDisable = [];
                if (yearNo <= self.year) { /* Current Year */
                  for (let j = 1; j < item.monthView.length; j++) {
                    if (j > monthNo) {
                      monthDisable[j] = true;
                    }
                    else if (j <= monthNo) {
                      if(item.monthView[j].hasKpiData) {
                        monthDisable[j] = false;
                        monthQtyItem[j] = item.monthView[j].monthQty;
                        monthDisable[j] = item.monthView[j].isDisableMonth;
                      }
                    }
                    else {
                      monthQtyItem[j] = item.monthView[j].monthQty;
                      monthDisable[j] = item.monthView[j].isDisableMonth;
                      monthDisable[j] = true;
                    }
                  }
                }
                else { /* Previous Year */
                  for (let j = 1; j < item.monthView.length; j++) {
                    if(item.monthView[j].hasKpiData) {
                      monthQtyItem[j] = item.monthView[j].monthQty;
                    }

                    //if (self.year == yearNo) {
                    //  monthDisable[j] = false;
                    //}
                    //else {
                    //  monthDisable[j] = true;
                    //}

                    //==== Check with config ====
                    if (self.year < yearNo) {
                        const currentMonth = new Date().getMonth() + 1;

                        console.log("Current Year : " + yearNo);
                        console.log("Current Month : " + currentMonth);
                        console.log("Previous Year : " + self.year);
                        console.log("Editable Month : " + self.monthCanEdit);

                        if (currentMonth <= self.monthCanEdit) {
                            //
                            monthDisable[j] = false; // < ภายในเดือนที่ระบุใน config ให้แก้ไขได้
                        } else {
                            //
                            monthDisable[j] = true;
                        }
                    }
                    else {
                        monthDisable[j] = false;
                    }
                  }
                }

                self.productitems.push({
                  productCode: item.productCode,
                  productCost: item.productCost,
                  isMonth: monthQtyItem,
                  isDisableMonth: monthDisable,
                  isDisableProduct: true,
                  productCodeOptionsData: {
                    id: item.productCode,
                    text: item.productName + " [" + item.productCode + "]",
                    data: null,
                  },
                });

                setTimeout(function() {
                  self.$refs.Items[i].$refs.productCode.setSelectedData(
                    self.productitems[i].productCodeOptionsData
                  );
                  self.changeTotal();
                }, 100);
              }
              self.isShow = true;
            } else {
              self.changeTotal();
            }
          } else {
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลที่คุณเลือก", "warning");
            router.go(-1);
            self.isShow = false;
          }
        })
        .catch(function(error) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้",
            "error"
          );
          router.go(-1);
          self.isShow = false;
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    changeTotal() {
      this.totalCost = 0;
      this.totalMonth = [];
      this.totalPoductCost = 0;
      this.totalProductCostOfMonth = 0;
      this.productitems.forEach((e) => {
        this.totalCost = this.totalCost + Number(e.productCost);
        this.totalPoductCost = this.totalPoductCost + Number(e.totalCost);
        this.totalProductCostOfMonth =
          this.totalProductCostOfMonth + Number(e.totalCalOfmonth);
        for (var i = 1; i < e.isMonth.length; i++) {
          if (e.isMonth[i] != null) {
            var oldtotal =
              this.totalMonth[i] == undefined ? 0 : this.totalMonth[i];
            this.totalMonth[i] = Number(e.isMonth[i]) + oldtotal;
          }
        }
      });
    },
    async exportExcelSelected() {
      if (this.isExportingSelected) return;
      if (!this.year) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
        return;
      }
      this.isExportingSelected = true;
      try {
        await exportExcelFromApi(
          "/Api/KPIProduct/Export/AccessoriesLost",
          { year: this.year, agentCode: this.agentCode || null },
          "รายงาน_อุปกรณ์ส่งเสริมสูญหาย.xlsx",
          this.$root.user && this.$root.user.access_token
        );
      } catch (err) {
        console.error("[KPI Export Selected]", err);
        const msg = (err.response && err.response.statusText) || err.message || "Export ล้มเหลว";
        Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });
      } finally {
        this.isExportingSelected = false;
      }
    },
    async exportExcelAllAgents() {
      if (this.isExportingAll) return;
      if (!this.year) {
        Swal.fire({ icon: "warning", title: "กรุณาเลือกปี", confirmButtonText: "OK" });
        return;
      }
      this.isExportingAll = true;
      try {
        await exportExcelFromApi(
          "/Api/KPIProduct/Export/AccessoriesLost/AllAgents",
          { year: this.year },
          "รายงาน_อุปกรณ์ส่งเสริมสูญหาย_ทุกตัวแทน.xlsx",
          this.$root.user && this.$root.user.access_token
        );
      } catch (err) {
        console.error("[KPI Export All]", err);
        const msg = (err.response && err.response.statusText) || err.message || "Export ล้มเหลว";
        Swal.fire({ icon: "error", title: "Export ล้มเหลว", text: msg });
      } finally {
        this.isExportingAll = false;
      }
    },
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      if(self.agentCode === null || self.agentCode == ""){
        Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณาเลือก ตัวแทนจำหน่าย",
            "warning"
          );
        return false;
      }
      if(self.productitems.length < 1){
        Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณาเพิ่มรายการอุปกรณ์ส่งเสริมสูญหาย",
            "warning"
          );
        return false;
      }

      var countRow = self.productitems[0].isMonth;
      for (let i = 0; i < self.productitems.length; i++) {
        if (self.productitems[i].isMonth.length == 0) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณากรอกจำนวนอุปกรณ์ส่งเสริมสูญหาย",
            "warning"
          );
          return false;
        }

        if (self.productitems[i].productCost == 0) {
          Swal.fire("เกิดข้อผิดพลาด", "กรุณากรอกจำนวนต้นทุนสินค้า", "warning");
          return false;
        }

        if (countRow.filter((o) => o != "").length != self.productitems[i].isMonth.filter((o) => o != "").length) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0",
            "warning"
          );
          return false;
        }
        else if (countRow.filter((o) => o != "").length == self.productitems[i].isMonth.filter((o) => o != "").length) {
          var data = self.productitems[i].isMonth.filter((o) => o != null);
          var row = self.productitems[0].isMonth.filter((o) => o != null);
          var deleteData = self.productitems[i].isMonth.filter((o) => o == "");
          var deletRow = row.filter((o) => o == "");

          if (row.length - deletRow.length != data.length - deleteData.length) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              "กรุณากรอกจำนวนสินค้าให้ครบในแต่ละเดือน ถ้าไม่มีจำนวนให้ใส่เลข 0",
              "warning"
            );
            return false;
          }
        }

        var date = new Date();
        var month = date.getMonth() + 1;
        if (self.productitems[i].isMonth.length <= month && new Date().getFullYear() == self.year) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "กรุณากรอกจำนวนสินค้าให้ครบทุกเดือนจนถึงเดือนปัจจุบัน",
            "warning"
          );
          return false;
        }

        if (self.productitems[i].isMonth.length <= 12) {
          if (self.year < new Date().getFullYear()) {
            Swal.fire(
              "เกิดข้อผิดพลาด",
              "กรุณากรอกจำนวนสินค้าให้ครบในทุกเดือน เนื่องจากเป็นการกรอกข้อมูลย้อนหลังปีปัจจุบัน",
              "warning"
            );
            return false;
          }
        }

        if (!(this.$root.canShow(["ADMIN_5S"]) || this.$root.canShow(["JOB_AGENT_KPI"]))) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "คุณไม่ได้รับสิทธิในการแก้ไขข้อมูล",
            "warning"
          );
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      var sItems = [];
      self.productitems.forEach((element) => {
        sItems.push({
          ProductCode: element.productCode,
          ProductCost: element.productCost,
          MonthQty: element.isMonth,
        });
      });
      axios({
        method: "post",
        url: "/Api/KPIProduct",
        data: {
          AgentCodes: self.agentCode,
          KPIProductType: self.kPIProductType,
          Year: self.year,
          KPIItem: sItems,
        },
      })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                self.agentCodeChange();
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;
    $(this.$refs.form).validate().settings.ignore = ":hidden";

    const res = await axios.get('/Api/KPIProduct/kpiconfig');
    this.monthCanEdit = res.data.monthCanEdit;
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/KPI/Products/AccessoriesLost.vue